import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {PWADetectorService, ScreenService} from '../../../../../shared/services/general';

@Component({
  selector: 'app-requisition-done-dialog',
  templateUrl: './requisition-done-dialog.component.html',
  styleUrls: ['./requisition-done-dialog.component.scss']
})
export class RequisitionDoneDialogComponent implements OnInit, OnDestroy {
  @Input() public popupVisible = false;
  @Input() public mode: 'create' | 'update' = 'create';
  @Input() public requisitionId: number = -1;
  @Output() public closeEvent = new EventEmitter();
  public isPhone: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private router: Router,
              private pwaDetectorService: PWADetectorService,
              private screen: ScreenService
  ) {
  }

  public ngOnInit() {
    this.isPhone = this.screen.sizes['screen-x-small'];
    this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.isPhone = this.screen.sizes['screen-x-small'];
    });
  }

  public redirectToNew() {
    if (this.pwaDetectorService.isPWA()) {
      this.router.navigate(['/secured/requisitions/create']);
    } else {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/secured/requisitions/create']),
      );
      window.open(url, '_self');
    }
  }

  public redirectToHome() {
    this.router.navigateByUrl('/secured/results/lab');
  }

  public redirectToEdit() {
    if (this.pwaDetectorService.isPWA()) {
      this.router.navigate(['/secured/requisitions/create', {id: this.requisitionId}]);
    } else {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/secured/requisitions/create', {id: this.requisitionId}]),
      );
      window.open(url, '_self');
    }
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
